<template>
    <div id="score-introduce" :class="theme">
        <img v-if="theme == 'day'" class="item-img item1" src="@/assets/introduce/item1.png" alt="">
        <img v-if="theme == 'day'"  class="item-img item2" src="@/assets/introduce/item2.png" alt="">
        <img v-if="theme == 'night'"  class="item-img item1" src="@/assets/introduce/item-b1.png" alt="">
        <img v-if="theme == 'night'"  class="item-img item2" src="@/assets/introduce/item-b2.png" alt="">
        <div class="content-box">
            <div class="part-one">
                <h1>尊敬的金果子用户：</h1>
                <p>伴随着金果子数据平台亮相大众视野，为了感谢用户们的大力支持与关注，金果子官方将设立金果子积分体系回馈广大用户。</p>
                <div class="space"></div>
                <p>在金果子积分体系中，用户可以通过平台中的各类活动获取积分，如邀请有奖、签到分享等。任何时间所获取的积分都会累计、叠加，用户在不同阶段可凭借积分兑换不同等级的权益。</p>
                <div class="space"></div>
                <p>金果子积分可用于兑换不同等级的神秘大礼，金果子将在不同时间段开启积分兑换通道，用户可将积攒的积分兑换相应的礼品。</p>
            </div>
            <div class="part-two">
                <h1>金果子积分将会实行累计、叠加的方式，在不同时期，官方会开放更丰富的积分权益，现阶段仅开放以下几类权益：</h1>
                <p>1、可进入金果子核心圈层，第一时间获取行业动态。 </p>
                <div class="space"></div>
                <p>2、获取更多不同维度的独家数据分析报告。 </p>
                <div class="space"></div>
                <p>3、兑换各类线下活动入场凭证，如峰会、论坛、酒会等。</p> 
                <div class="space"></div>
                <p>4、兑换各类合作资源，如媒体、交易、OTC、项目方等合作权益。</p> 
                <div class="space"></div>
                <p>5、兑换金果子平台内项目方糖果（以官方公告为主）。 </p>
                <div class="space"></div>
                <p>6、折扣兑换金果子通证、金果子专属周边等。 </p>
                <div class="space"></div>
                <p>7、拥有投票活动的投票权，包括：话题互动、线上活动、线上专题类大赛、社区投票等。</p>
            </div>
            <div class="part-three">
                <p>以上只是积分体系的冰山一角，我们将会持续不断的赋能金果子积分，为积分的持有者带来更多的权益，创造更大的价值。</p>
            </div>
            <div class="line"></div>
            <div class="part-four">
                <p>感谢您对金果子的支持!<br/>金果子官方团队<br/>2019年11月13日</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScoreIntroduce',
    data() {
        return {
            theme: 'day'
        }
    },
    
    mounted(){
        this.theme = this.$route.query.theme ? this.$route.query.theme : 'day';
    },

    methods: {

    }
}
</script>

<style lang='less'>
#score-introduce {
    height: 2006px;
	width: 100%;
    position: relative;
    background: #ffffff;
    font-family: PingFang SC;
    color: #33333A;
    &.night{
        color: #E3E3E1;
        background: #181820;
        .content-box .line {
            background: #2A2A36;
        }
        .content-box {
            background: #181820;
        }
    }
    .item-img {
        position: absolute;
        z-index: 0;
    }
    .item1 {
        top: 0;
        left: 0;
        width: 260px;
        height: 260px;
    }
    .item2{
        bottom: 0;
        right: 0;
        width: 360px;
        height: 360px;
    }
    .content-box {
        text-align: left;
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        padding: 70px 40px 40px 40px;
        h1 {
            font-size: 34px;
            font-weight: bold;
        }
        p {
            font-size: 30px;
            line-height: 45px;
        }
        .space {
            width: 100%;
            height: 20px;
        }
        .line {
            height: 1px;
            width: 100%;
            margin-bottom: 50px;
            background: #EBECF0;
        }
        .part-one {
            margin-bottom: 60px;
            h1 {
                line-height: 45px;
                margin-bottom: 20px;
            }
        }
        .part-two {
            margin-bottom: 50px;
            h1 {
                line-height: 50px;
                margin-bottom: 20px;
            }
        }
        .part-three {
            margin-bottom: 40px;
        }
        .part-four {
            text-align: right;
        }
    }
}
</style>
